import React from 'react';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

interface MockReadinessChartProps {
    variant?: 'full' | 'compact';
    className?: string;
}

const MOCK_DATA = {
    labels: ['HRV', 'RHR', 'Sleep', 'ACWR', 'Wellness'],
    datasets: [
        {
            label: 'Readiness',
            data: [82, 71, 88, 65, 77],
            backgroundColor: 'rgba(59, 130, 246, 0.15)',
            borderColor: '#3B82F6',
            borderWidth: 2,
            pointBackgroundColor: '#60A5FA',
            pointBorderColor: 'transparent',
            pointRadius: 3,
        },
    ],
};

const getOptions = (compact: boolean) => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        r: {
            angleLines: { color: 'rgba(255,255,255,0.08)' },
            grid: { color: 'rgba(255,255,255,0.08)' },
            pointLabels: {
                color: 'rgba(255,255,255,0.5)',
                font: { size: compact ? 9 : 11, family: 'Inter, sans-serif' },
            },
            ticks: {
                display: false,
            },
            suggestedMin: 0,
            suggestedMax: 100,
        },
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    events: [] as const,
});

const MockReadinessChart: React.FC<MockReadinessChartProps> = ({ variant = 'full', className = '' }) => {
    const compact = variant === 'compact';
    const height = compact ? 160 : 220;

    return (
        <div className={`relative ${className}`} style={{ height }}>
            <Radar data={MOCK_DATA} options={getOptions(compact)} />
        </div>
    );
};

export default MockReadinessChart;
